(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
    Marks the header once the page has actually scrolled, so it can go from
    transparent to solid white. StickyHeader above cannot be used for this:
    with "Always sticky" it adds shopify-section-header-sticky during
    connectedCallback, before any scrolling, so that class says nothing about
    where the page is.

    One listener on the window; the header is looked up each time so the theme
    editor swapping the section out never leaves a stale reference behind.
  */
  (function () {
    // A little slack so momentum scrolling at the very top does not flicker.
    var THRESHOLD = 8;
    var ticking = false;

    function applyScrolledState() {
      ticking = false;
      var header = document.querySelector('.section-header');
      if (!header) return;
      header.classList.toggle('jmc-header--scrolled', window.scrollY > THRESHOLD);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(applyScrolledState);
      },
      { passive: true }
    );

    document.addEventListener('shopify:section:load', applyScrolledState);
    applyScrolledState();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jmc-hero"] && !Shopify.designMode) return;
  try {
    
  /*
    Hero video lightbox.

    The iframe is created on open and destroyed on close. That keeps the video
    off the initial page load entirely, and removing the element is also what
    stops playback — pausing a cross-origin iframe is not something we can do.
  */
  (function () {
    function build(url) {
      var f = document.createElement('iframe');
      f.src = url + '?autoplay=true&loop=false&muted=false&preload=true&responsive=true';
      f.setAttribute('allow', 'accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;fullscreen;');
      f.setAttribute('allowfullscreen', 'true');
      f.setAttribute('title', document.title);
      return f;
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-jmc-video-open]');
      if (opener) {
        var section = opener.closest('.jmc-hero');
        var modal = section && section.querySelector('[data-jmc-video-modal]');
        if (!modal || typeof modal.showModal !== 'function') return;
        var slot = modal.querySelector('[data-jmc-video-slot]');
        slot.replaceChildren(build(opener.getAttribute('data-jmc-video-open')));
        modal.showModal();
        return;
      }

      var closer = event.target.closest('[data-jmc-video-close]');
      if (closer) {
        closer.closest('dialog').close();
        return;
      }

      /* Clicking the backdrop lands on the dialog itself, not its contents. */
      if (event.target.matches('[data-jmc-video-modal]')) event.target.close();
    });

    /* Covers Escape as well as the buttons above — both fire 'close'. */
    document.addEventListener(
      'close',
      function (event) {
        if (!event.target.matches('[data-jmc-video-modal]')) return;
        var slot = event.target.querySelector('[data-jmc-video-slot]');
        if (slot) slot.replaceChildren();
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
